const SERVER_URL = 'https://shots-sparrow.hasura.app/v1/graphql';

export default SERVER_URL;
